import React from 'react';

interface IEvePriceCalculatorSelectProps {
    label: string;
    selectName: string;
    value: string;
    getOptions: (selectLabel: string) => string[];
    onChange: (name: string, value: string) => void;
}

export const EvePriceCalculatorSelect: React.FC<IEvePriceCalculatorSelectProps> = props => {
    const { label, selectName, value, onChange, getOptions } = props;

    const className = `eve-price-calculator-display__form-row-${selectName}`;
    const options = getOptions(label);

    /**
     * Emits select change
     * @param e Event
     */
    const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>): void => onChange(e.target.name, e.target.value);

    return (
        <div className={`${className}`}>
            <label className={`${className}--label`} htmlFor={selectName}>
                {label}
            </label>
            {options ? (
                <select id={selectName} className={`${className}--select`} name={selectName} value={value} onChange={handleOnChange}>
                    {options.map((option, index) => {
                        if (index === 0) {
                            return (
                                <option key={`${option}-${index}`} value={option} selected>
                                    {option}
                                </option>
                            );
                        }
                        return (
                            <option key={`${option}-${index}`} value={option}>
                                {option}
                            </option>
                        );
                    })}
                </select>
            ) : (
                <></>
            )}
        </div>
    );
};
